import classnames from 'classnames';
import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useGrid } from '../provider';
import ClassificationResultsFilter from './classification_results_filter';
const capitalizeAcronyms = {
    'Sic Code': 'SIC Code',
    'Naics Code': 'NAICS Code',
    'Fein Code': 'FEIN Code',
    'Ern Number': 'ERN Number',
};
const TitleColumn = () => {
    var _a, _b;
    const { hasPermission } = useUser();
    const { filteredTagsColumn, categories, descriptors, selectedCategories, setSelectedCategories, selectedDescriptors, setSelectedDescriptors, selectedRowIndex, setSelectedRowIndex, areChecklistItemsVisible, setAreChecklistItemsVisible, areCommentsVisible, } = useGrid();
    const scrollSpaceClass = classnames('scroll-space anchor', {
        'dec-page': ((_a = filteredTagsColumn[0]) === null || _a === void 0 ? void 0 : _a.category.display) === 'Dec Page Fields',
        'clause': ((_b = filteredTagsColumn[0]) === null || _b === void 0 ? void 0 : _b.category.display) === 'Clauses',
    });
    let startingIndex = 0;
    return (React.createElement("div", { className: 'anchor-titles' },
        React.createElement("div", { className: 'header cell', id: '0-0', "data-testid": 'cell-0-0' },
            React.createElement("div", { className: 'category-title', "data-testid": 'grid-view-category-select-trigger' },
                React.createElement("h5", { "data-public": true }, "Classifications"),
                React.createElement(ClassificationResultsFilter, { categories: categories, selectedCategories: selectedCategories, setSelectedCategories: setSelectedCategories, descriptors: descriptors, selectedDescriptors: selectedDescriptors, setSelectedDescriptors: setSelectedDescriptors }))),
        React.createElement("div", { className: scrollSpaceClass }),
        filteredTagsColumn.map(classification => {
            var _a;
            const rowIndex = startingIndex + 1;
            const columnId = 0;
            const cellId = `${columnId}-${rowIndex}`;
            const activeRow = selectedRowIndex === rowIndex;
            startingIndex++;
            const category = classification.category.display;
            const descriptor = classification.descriptor.display;
            const cellClassName = classnames('title cell', {
                active: activeRow,
                'comments-visible': areCommentsVisible,
                'dec-page': category === 'Dec Page Fields',
                'clause': category === 'Clauses',
            });
            const checklistIconClass = classnames('click-icon', { active: areChecklistItemsVisible });
            const titleCategoryClass = classnames('title-category', { active: activeRow });
            let subRowIndex = 0;
            return React.createElement(React.Fragment, null,
                React.createElement("div", { key: cellId, "data-testid": `cell-${cellId}`, className: cellClassName, onClick: () => setSelectedRowIndex(rowIndex) },
                    category !== '' && React.createElement("div", { className: titleCategoryClass }, category.toUpperCase()), (_a = capitalizeAcronyms[descriptor]) !== null && _a !== void 0 ? _a : descriptor.replaceAll('100 Pct ', ''),
                    activeRow && (React.createElement("div", { className: 'icons' }, classification.category.key === 'clauses' && (React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_COMPARISON_CHECKLIST_ITEMS] },
                        React.createElement("span", { className: checklistIconClass, title: 'Show Checklist Items', onClick: () => setAreChecklistItemsVisible(!areChecklistItemsVisible) },
                            React.createElement("i", { className: 'fa-align-justify fad fa-tasks' }))))))),
                activeRow && areChecklistItemsVisible &&
                    hasPermission(Permissions.VIEW_COMPARISON_CHECKLIST_ITEMS) &&
                    classification.category.key === 'clauses' &&
                    classification.descriptor.subRows.length > 0 &&
                    classification.descriptor.subRows.map(checkList => {
                        const subCellId = `${columnId}-${rowIndex}-${subRowIndex}`;
                        subRowIndex++;
                        return React.createElement("div", { key: subCellId, "data-testid": `cell-${subCellId}`, className: 'title cell checklist', onClick: () => setSelectedRowIndex(rowIndex) }, checkList.descriptor.display);
                    }));
        })));
};
export default TitleColumn;
